import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LocaleGuard } from './core/locale/locale.guard';
import { LocaleService } from './core/locale/locale.service';
import { UserService } from './core/user/user.service';

@Component({
  selector: 'cp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  constructor(
    translate: TranslateService,
    userService: UserService,
    localeService: LocaleService,
    localeGuard: LocaleGuard
  ) {
    translate.setDefaultLang('en');

    localeService
      .setLocale$(localeService.getLocaleOrDefault())
      .subscribe(() => localeGuard.languageLoaded.next({}));

    userService
      .getCurrentUser()
      .subscribe(profile => userService.setFromProfile(profile), () => userService.setAnonymous());
  }
}
